<template>
  <div>
        <span @click="search()">
            <Button type="primary" @click="modal = true"
                    v-hasPermission="['approvalFlowConfiguration:approvalFlowConfiguration:add_approval_flow']">{{$t('approvalFlowConfigManagement.approvalFlow.addApprovalFlow')}}</Button>
        </span>

    <Modal v-model="modal" :title="$t('approvalFlowConfigManagement.approvalFlow.addApprovalFlow')" :loading="loading"
           :mask-closable="false"
           :styles="{top:'65px'}" width="900px;" :closable="false" @on-ok="caseSubmit('approvalFlowConfigurationForm')"
           @on-cancel="caseReset('approvalFlowConfigurationForm')"
           :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="approvalFlowConfigurationForm" :model="approvalFlowConfigurationForm" :label-width="120"
            :rules="ruleValidate">
        <Row>
          <Col span="12">
            <!-- 审批流名称 -->
            <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.approvalFlowName')" prop="processName">
              <Input v-model="approvalFlowConfigurationForm.processName" style="width:231px;" placeholder="Enter something..."></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <!-- 类型 -->
            <FormItem :label="$t('approvalFlowConfigManagement.Node.type')" prop="type">
              <Select v-model="approvalFlowConfigurationForm.type" style="width:231px;" :placeholder="$t('configuration_management.common.pleaseSelect')">
                <Option :value="item.id" v-for="item in typeList" v-bind:key="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="12">
            <!-- 审批流所属公司 -->
            <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.approvalFlowCompany')" prop="companyId">
              <Select v-model="approvalFlowConfigurationForm.companyId" style="width:231px;"
                      :placeholder="$t('approvalFlowConfigManagement.approvalFlow.pleaseSelectCompany')">
                <Option :value="item.id" v-for="item in companyIdList" v-bind:key="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <!-- 节点 -->
        <FormItem :label="$t('approvalFlowConfigManagement.Node.nodeCompany')" style="margin-bottom: 50px;">
          <flow-panel ref="flowPanel"></flow-panel>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import FlowPanel from '@/components/ef/panel'
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableApprovalFlowConfiguration from '../approval_flow/TableApprovalFlowConfiguration.vue'

  var tableApprovalFlowConfiguration = TableApprovalFlowConfiguration;
  export default {
    components: {
      FlowPanel
    },
    data() {
      return {
        approvalFlowConfigurationForm: {
          processName: '',
          type: '',
          companyId: ''
        },
        typeList: [],
        companyIdList: [],
        loading: true,
        modal: false,
        ruleValidate: {
          processName: [
            {required: true, message: this.$t('approvalFlowConfigManagement.approvalFlow.flowNameNotEmpty'), trigger: 'blur'},
            {type: 'string', message: this.$t('approvalFlowConfigManagement.approvalFlow.flowNameValidateMsg'), pattern: '^.{4,20}$', trigger: 'blur'}
          ],
          type: [
            {required: true, message: this.$t('approvalFlowConfigManagement.approvalFlow.pleaseSelectType'), trigger: 'change', type: 'number'}
          ],
          companyId: [
            {required: true, message: this.$t('approvalFlowConfigManagement.Node.pleaseSelectCompany'), trigger: 'change', type: 'number'}
          ]
        }
      }
    },
    methods: {
      // 查询
      search: function () {
        this.getCompanyDropDownBox();
        this.$api.processTemplate.processTypes("userName", getCookie(global.cookieName))
          .then(res => {
            this.typeList = res.data;
          })
      },
      //公司下拉框
      getCompanyDropDownBox: function () {
        this.$api.company.getCompanyDropDownBox()
          .then(res => {
            this.companyIdList = res.data;
          })
      },
      caseSubmit: function (name) {
        this.$refs[name].validate(valid => {
          if (valid && this.$refs.flowPanel.flowNodeName.length > 0) {
            // 添加
            this.$api.processTemplate.createProcessTemplate({
              "name": this.approvalFlowConfigurationForm.processName,
              "companyId": this.approvalFlowConfigurationForm.companyId,
              "processNodeIds": this.$refs.flowPanel.flowNodeName,
              "type": this.approvalFlowConfigurationForm.type
            })
              .then(res => {
                this.data = res.data;
                setTimeout(() => {
                  tableApprovalFlowConfiguration.methods.showAll();
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t('common.addSuccess'));
                  // 清空节点页面
                  this.$refs.flowPanel.dataReload({
                    name: '',
                    nodeList: [],
                    lineList: []
                  });
                  // 清空公司下拉选内容
                  this.$refs.flowPanel.deleteCompany();
                  this.$refs.flowPanel.flowNodeName = [];
                  this.$refs.flowPanel.activeElement = {type: undefined};
                  this.modal = false;
                }, 1000);
              })
          } else {
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            this.$Message.error(this.$t('common.addFail'));
          }
        });
      },
      caseReset: function (name) {
        this.modal = false;
        // 清空节点页面
        this.$refs.flowPanel.dataReload({
          name: '',
          nodeList: [],
          lineList: []
        });
        // 清空公司下拉选内容
        this.$refs.flowPanel.deleteCompany();
        this.$refs.flowPanel.flowNodeName = [];
        this.$refs.flowPanel.activeElement = {type: undefined};
        this.$refs[name].resetFields();
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/approval_flow/AddApprovalFlowConfiguration.vue